import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TablePagination,
  Box,
  IconButton,
  useTheme,
  TableHead,
  TextField,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
} from "@mui/material";
import { useState, MouseEvent } from "react";
import { KeyboardArrowRight, KeyboardArrowLeft } from "@mui/icons-material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "../../../routes/moduleRouteList";
import patientCareRouteList from "../../routeList";
import { blue, green } from '@mui/material/colors';
const base = (window as any)._env_?.BASE_URL;

import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import { useQuery } from "react-query";
import { getBillingList } from "../services";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import usePopup from "../../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";
dayjs.extend(utc);
function TablePaginationActions(props: {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

function BillingPatients() {
  const theme = useTheme();
  const navigateTo = useNavigate();
  const { showSnackbar } = usePopup();
  const [searchParams, setSearchParams] = useState<{
    filter: {
      search: string;
      searchDate: Dayjs;
      paymentMode: number | null;
    };
    pageSize?: number;
    pageNumber?: number;
  }>({
    filter: {
      search: "",
      searchDate: dayjs(),
      paymentMode: 2,
    },
    // searchText: "",
    // searchDate: dayjs(),
    // searchCashType: 2,
    pageSize: 25,
    pageNumber: 0,
  });

  const handleChangePage = (
    _: MouseEvent<HTMLButtonElement> | null,
    pageNumber: number
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const { data: billingData, isLoading: billingLoading } = useQuery(
    ["getBillingList", searchParams],
    () => getBillingList(searchParams),
    {
      onError: (e: any) => {
        showSnackbar({
          message: e?.response?.data?.responseMessage || "Error !",
          open: true,
          variant: "error",
          duration: 4000,
        });
      },
      retry: 3,
    }
  );

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      pageSize: parseInt(event.target.value, 10),
      pageNumber: 0,
    }));
  };

  const handleNavigation = (e: MouseEvent<HTMLElement>) => {
    const patientId = e.currentTarget.getAttribute("data-patientid");
    const emrNo = e.currentTarget.getAttribute("data-emrno");
    navigateTo(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.billingDetails}/${patientId}?emrno=${emrNo}`
    );
  };

    const{user}= useAuthentication();
 const regionValue= user?.region;
   const idHeading =
  regionValue === "QATAR_REGION"
    ? "CIVIL ID"
    : "CIVIL ID";

  const heading = [
  "Sl no",
  "Emr No/Reg No",
  "Name",
  idHeading,
  "Payment mode",
  "Registration Date",
];

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div className="flex flex-row gap-2 items-end p-2">
        <div className="">
          <TextField
            label="Search"
            onChange={(e) => {
              setSearchParams((prev) => ({
                ...prev,
                filter: {
                  ...prev.filter,
                  search: e.target.value,
                },
              }));
            }}
          />
        </div>
        <div className="">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <DatePicker
                // disabled={
                //   timeSlot.slotType != "dayGridMonth" &&
                //   timeSlot.slotType != "multiMonthYear"
                // }
                label={
                  <span>
                    Date
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </span>
                }
                format="DD-MM-YYYY"
                timezone="UTC"
                value={dayjs(searchParams.filter.searchDate)}
                onChange={(date) => {
                  setSearchParams((prev) => ({
                    ...prev,
                    filter: { ...prev.filter, searchDate: date || dayjs() },
                  }));
                }}
                slotProps={{
                  textField: {
                    //   error: !!error,
                    //   helperText: error?.message,
                    //   InputProps: { readOnly: true },
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
        <div className="col-span-2 flex flex-row items-center gap-3">
          <FormLabel id="demo-row-radio-buttons-group-label">
            Patient type
          </FormLabel>
          <RadioGroup
            row
            defaultValue={searchParams.filter.paymentMode}
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={(e) => {
              setSearchParams((prev) => ({
                ...prev,
                filter: {
                  ...prev.filter,
                  paymentMode: parseInt(e.target.value),
                },
              }));
            }}
          >
            <FormControlLabel value={2} control={<Radio />} label="All" />
            <FormControlLabel value={0} control={<Radio />} label="Cash" />
            <FormControlLabel value={1} control={<Radio />} label="Insurance" />
          </RadioGroup>
        </div>
      </div>
      <TableContainer sx={{ flexGrow: 1, overflow: "auto", px: 1 }}>
        <div className="h-[calc(100vh-270px)]">
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {heading.map((item, index) => (
                  <TableCell
                    key={index}
                    sx={(theme) => ({
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.background.paper,
                    })}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <CustomTableBody
              alert={"There is no encounter for billing"}
              dataLoading={billingLoading}
              isData={Boolean(billingData?.response?.items?.length)}
              totalSpan={{ col: heading.length, row: 5 }}
            >
              {billingData?.response?.items?.map((row, i) => (
                <TableRow
                  data-patientid={row.encounterId}
                  data-emrno={row.emrNo}
                  onClick={handleNavigation}
                  hover
                  key={i + 1}
                  className="cursor-pointer"
                >
                  <TableCell>
                    {(searchParams.pageNumber as number) *
                      (searchParams.pageSize as number) +
                      (i + 1)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.emrNo}
                  </TableCell>
                  <TableCell>{row.patientName}</TableCell>
                  <TableCell>{row.emiratesId || row.gccId ||row.passportNum}</TableCell>
                  <TableCell>
                    {row.paymentMode ? (
                      <Chip
                      sx={{ width: 80,backgroundColor:green[50],border:0,color:theme.palette.success.main,fontWeight:600 }}
                        variant="outlined"
                        size="small"
                        label="Insurance"
                      />
                    ) : (
                      <Chip
                        // color="success"
                        variant="outlined"
                        sx={{ width: 80,backgroundColor:blue[50],border:0,color:theme.palette.primary.main,fontWeight:600 }}
                        size="small"
                        label="Cash"
                      />
                    )}
                  </TableCell>
                  <TableCell>{row.registrationDate}</TableCell>
                </TableRow>
              ))}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
            </CustomTableBody>
          </Table>
        </div>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={billingData?.response?.totalCount || 0}
        rowsPerPage={searchParams.pageSize || 0}
        page={searchParams.pageNumber || 0}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </Box>
  );
}

export default BillingPatients;
